import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../services/api';
import './ForgotPassword.css'; // Reuse auth page styles

function VerifyEmail() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setError('Invalid verification link');
        setLoading(false);
        return;
      }

      try {
        await authAPI.verifyEmail(token);
        setSuccess(true);
        setError('');

        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to verify email');
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [token, navigate]);

  if (loading) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>⏳ Verifying Email...</h1>
            <p>Please wait while we verify your email address</p>
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>✅ Email Verified!</h1>
            <p>Your email has been successfully verified.</p>
          </div>
          <div className="success-message">
            Redirecting to login in 3 seconds...
          </div>
          <button className="btn btn-primary" onClick={() => navigate('/login')}>
            Go to Login Now
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>❌ Verification Failed</h1>
          <p>{error}</p>
        </div>
        <div className="error-message">
          {error.includes('expired')
            ? 'Your verification link has expired. Please register again or contact support.'
            : 'This verification link is invalid.'}
        </div>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button className="btn btn-primary" onClick={() => navigate('/register')}>
            Register Again
          </button>
          <button className="btn btn-primary" onClick={() => navigate('/login')}>
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
